import { Flame, Send } from "lucide-react";
import { SITE } from "@/data/site";
import { CopyContract } from "@/components/CopyContract";

const XIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>
);

export const Footer = () => {
  return (
    <footer
      className="relative border-t border-white/10 bg-surface/60 pt-16 pb-8 overflow-hidden"
      data-testid="footer"
    >
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[600px] h-[300px] bg-ember/10 blur-[130px] rounded-full" />
      <div className="relative z-10 max-w-7xl mx-auto px-5 md:px-8">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-8 pb-10">
          <div>
            <div className="flex items-center gap-2 mb-3">
              <Flame className="w-7 h-7 text-ember" />
              <span className="font-display text-2xl text-white uppercase">{SITE.name}</span>
            </div>
            <p className="font-body text-sm text-gray-400 max-w-xs">{SITE.tagline}</p>
          </div>

          <div className="flex items-center gap-4">
            <a
              href={SITE.links.twitter}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-twitter"
              className="w-11 h-11 rounded-md glass flex items-center justify-center text-white hover:bg-white hover:text-black transition-colors duration-300"
              aria-label="Twitter"
            >
              <XIcon className="w-5 h-5" />
            </a>
            <a
              href={SITE.links.telegram}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-telegram"
              className="w-11 h-11 rounded-md glass flex items-center justify-center text-solana hover:bg-solana hover:text-white transition-colors duration-300"
              aria-label="Telegram"
            >
              <Send className="w-5 h-5" />
            </a>
            <a
              href={SITE.links.pumpfun}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-pumpfun"
              className="inline-flex items-center gap-2 bg-gold hover:bg-gold-hover text-black font-body font-extrabold text-sm px-5 py-2.5 rounded-md transition-colors duration-300 uppercase tracking-wide"
            >
              <Flame className="w-4 h-4" /> Buy {SITE.ticker}
            </a>
          </div>
        </div>

        <div className="pb-8">
          <p className="font-body text-xs font-semibold tracking-widest uppercase text-gray-500 mb-2">
            Contract Address
          </p>
          <CopyContract testId="footer-copy-contract" />
        </div>

        <div className="border-t border-white/10 pt-6 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <p className="font-body text-xs text-gray-500">
            © {new Date().getFullYear()} {SITE.name} ({SITE.ticker}). All rights reserved.
          </p>
          <p className="font-body text-xs text-gray-600 max-w-2xl md:text-right leading-relaxed">
            <span className="text-gray-400 font-semibold">Disclaimer:</span> $TGB is a meme coin
            with no intrinsic value or expectation of financial return. This site is for
            entertainment purposes only and is not financial advice. Crypto is highly volatile —
            always DYOR and never invest more than you can afford to lose.
          </p>
        </div>
      </div>
    </footer>
  );
};
